var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 19.0001C14.2777 18.9995 14.1468 18.9727 14.0249 18.9212C13.9031 18.8697 13.7926 18.7945 13.7 18.7001L7.78 12.7501C7.59375 12.5627 7.48921 12.3092 7.48921 12.0451C7.48921 11.7809 7.59375 11.5274 7.78 11.3401L13.7 5.41006C13.8883 5.22175 14.1437 5.11597 14.41 5.11597C14.6763 5.11597 14.9317 5.22175 15.12 5.41006C15.3083 5.59836 15.4141 5.85376 15.4141 6.12006C15.4141 6.38636 15.3083 6.64175 15.12 6.83006L9.9 12.0001L15.12 17.2201C15.2888 17.3537 15.4099 17.5382 15.4654 17.7462C15.5209 17.9542 15.5078 18.1746 15.4281 18.3745C15.3483 18.5745 15.2062 18.7434 15.0227 18.8561C14.8393 18.9688 14.6244 19.0193 14.41 19.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/IconLeft.5b00535569d826677c485cffa0c02aef.svg";
export { ForwardRef as ReactComponent };